module.exports = __webpack_public_path__ + "static/media/document-loading-green.18f83c52.svg";